<template>
  <!-- 群蜂弹窗广告（独立组件，SDK自带遮罩和关闭） -->
  <div
    :id="containerId"
    class="qunfeng-popup-root"
    :class="{ 'qunfeng-popup-root--prefetch': prefetched && !revealed }"
  ></div>
</template>
<script>
import { getAdPositionId } from '../../../config/adConfig'

let popupCounter = 0
// margin-top 对齐 P云弹窗关闭区；padding 收紧 SDK 默认 0.5rem 避免间距过大
const QUNFENG_CLOSE_MARGIN_TOP = '0.1rem'
const QUNFENG_CLOSE_PADDING = '0.1rem'

export default {
  name: 'QunfengPopup',
  props: {
    // 广告位标识，如 HOME_POPUP、EXIT_ORDER_POPUP
    positionKey: {
      type: String,
      default: 'HOME_POPUP'
    }
  },
  data () {
    return {
      containerId: 'qunfeng-popup-' + (++popupCounter),
      adLoaded: false,
      prefetched: false,
      revealed: false
    }
  },
  beforeDestroy () {
    document.body.classList.remove('qunfeng-popup-prefetching')
  },
  methods: {
    prefetch () {
      if (this.adLoaded) return
      this.prefetched = true
      document.body.classList.add('qunfeng-popup-prefetching')
      this._loadAd()
      this.adLoaded = true
    },
    isPrefetched () {
      return this.adLoaded && this.prefetched && !this.revealed
    },
    reveal () {
      if (!this.adLoaded) {
        this.show()
        return
      }
      this.revealed = true
      this.prefetched = false
      document.body.classList.remove('qunfeng-popup-prefetching')
      this.$nextTick(() => {
        this.fixPopupSize()
      })
    },
    show () {
      if (this.adLoaded && this.prefetched && !this.revealed) {
        this.reveal()
        return
      }
      if (this.adLoaded) return

      this.revealed = true
      this.prefetched = false
      document.body.classList.remove('qunfeng-popup-prefetching')
      this._loadAd()
      this.adLoaded = true
      this.fixPopupSize()
    },
    _loadAd () {
      const positionId = getAdPositionId(this.positionKey)
      if (!positionId) {
        console.warn('[QunfengPopup]', this.positionKey, '未配置群蜂广告位')
        return
      }
      if (typeof window.qfAd === 'undefined') {
        console.error('[QunfengPopup] SDK未加载，请确保已引入 ad.min.js')
        return
      }

      const sid = this.$store.state.sid.sid || ''
      console.log('[QunfengPopup] 加载, positionKey:', this.positionKey, 'positionId:', positionId, 'sid:', sid)

      try {
        // eslint-disable-next-line no-new, new-cap
        new window.qfAd({
          containerId: this.containerId,
          positionId: positionId,
          projeckNo: sid
        })
      } catch (err) {
        console.error('[QunfengPopup] 加载失败', err)
      }
    },
    fixPopupSize () {
      var self = this
      // 多次尝试，等弹窗渲染完成
      var attempts = [300, 600, 1000, 2000]
      attempts.forEach(function (delay) {
        setTimeout(function () {
          self._applySize()
          self._fixCloseButton()
        }, delay)
      })
    },
    _fixCloseButton () {
      var imgs = this._getCloseButtonImgs()
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.setProperty('margin-top', QUNFENG_CLOSE_MARGIN_TOP, 'important')
        imgs[i].style.setProperty('margin-bottom', '0', 'important')
        imgs[i].style.setProperty('padding', QUNFENG_CLOSE_PADDING, 'important')
      }
    },
    _getCloseButtonImgs () {
      var container = document.getElementById(this.containerId)
      if (container) {
        var inContainer = container.querySelectorAll('img[id^="closeAd-"]')
        if (inContainer.length) return inContainer
      }
      // 通道付等场景 SDK 可能把关闭按钮挂在容器外，兜底全局查找
      return document.querySelectorAll('img[id^="closeAd-"]')
    },
    _applySize () {
      var container = document.getElementById(this.containerId)
      if (!container) return

      // 仅缩放当前弹窗容器，避免误改 SDK 遮罩层（通道付 EXIT_ORDER_POPUP 与首页 HOME_POPUP 一致）
      container.style.transform = 'scale(1.35)'
      container.style.transformOrigin = 'center center'
      console.log('[QunfengPopup] 已整体缩放1.35倍, container:', this.containerId)
    }
  }
}
</script>
<style>
.qunfeng-popup-root {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10001;
  pointer-events: none;
}
.qunfeng-popup-root > * {
  pointer-events: auto;
}
.qunfeng-popup-root--prefetch {
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
  z-index: -1 !important;
}
/* 预拉取阶段隐藏 SDK 注入到 body 的遮罩与关闭按钮 */
body.qunfeng-popup-prefetching > div[id^="containAd-"],
body.qunfeng-popup-prefetching img[id^="closeAd-"] {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
  position: fixed !important;
  left: -9999px !important;
  top: -9999px !important;
}
/* 群蜂弹窗读秒修复（项目 html font-size 较大，SDK 读秒继承后巨大） */
[id^="advert-"] {
  font-size: 14px !important;
}
/* 群蜂弹窗关闭按钮：margin 0.1rem 对齐 P云，padding 收紧 SDK 默认 0.5rem */
img[id^="closeAd-"] {
  margin-top: 0.3rem !important;
  margin-bottom: 0 !important;
  padding: 0.1rem !important;
}
</style>
